const { API_SERVER = "http://localhost:8000" } = process.env;

export default API_SERVER;



// WEBPACK FOOTER //
// /src/network.js